export const CALENDAR_DRAGGABLE_CARD = 'cal-draggable-card';
export const CALENDAR_DRAGGABLE_CONTENT = 'cal-draggable-content';
export const CALENDAR_FAVORITE_CONTAINER = 'cal-favorite-list';
export const CALENDAR_RECENT_CONTAINER = 'cal-recent-list';
